module.exports = __webpack_public_path__ + "img/seed.3a9f22b5.png";